import {
  FormField,
  PhoneInputField,
} from '@codev/helix-react';
import {isValidNumber} from 'libphonenumber-js';
import PropTypes from 'prop-types';
import React from 'react';
import translations from './translations.js';

const View = ({
  hasExistingNumber,
  language = 'en_US',
  onChange,
  phoneNumber,
  style,
  ...rest
}) => (
  <div
    {...rest}
    style={{
      fontSize: '16px',
      marginBottom: '20px',
      ...style
    }}
  >
    <p style={{marginBottom: '20px'}}>
      {
        hasExistingNumber ?
          translations('stepTextExisting', language) :
          translations('stepText', language)
      }
    </p>

    <FormField
      isRequired
      isRequiredErrorMessage={translations('isRequiredMessage', language)}
      validate={[
        () => {
          if (!isValidNumber(phoneNumber)) {
            return translations('invalidNumberMessage', language);
          }
        },
      ]}
      value={phoneNumber}
    >
      <PhoneInputField
        autoFocus
        onChange={onChange}
        value={phoneNumber}
      />
    </FormField>
  </div>
);

View.defaultProps = {
  phoneNumber: '',
};

View.propTypes = {
  onChange: PropTypes.func.isRequired,
  phoneNumber: PropTypes.string,
  style: PropTypes.object,
};

export default View;